import React from 'react'
import { Outlet } from 'react-router-dom'

const AuditLog = () => {
  return (
    <>
      <Outlet />
    </>
  )
}

export default AuditLog
